import "./rate.css";
import { Rate } from './rate';
export default Rate;